import React from 'react';

import SiteCard from 'src/components/eval/SiteCard';
import TimeWindowSelector from 'src/components/eval/TimeWindowSelector';
import LoadingSpinner from 'src/components/LoadingSpinner';
import PageContainer from 'src/components/PageContainer';
import PageTitle from 'src/components/PageTitle';
import {useEvalSites} from 'src/hooks/eval/useEvalSites';
import {useCurrentOrgIdPrefix} from 'src/hooks/useCurrentOrgIdPrefix';
import {TimeWindow} from 'src/lib/api/eval';

export default function EvalOverview() {
  const currentOrgIdPrefix = useCurrentOrgIdPrefix();

  const [window, setWindow] = React.useState<TimeWindow>('30d');
  const {sites, isLoaded} = useEvalSites();

  return (
    <PageContainer>
      <PageTitle
        pageStack={[{title: 'Eval', to: '/eval'}]}
        additionalContent={
          <div className="ml-4">
            <TimeWindowSelector value={window} onChange={setWindow} />
          </div>
        }
      />

      {!isLoaded && (
        <div className="py-6">
          <LoadingSpinner />
        </div>
      )}

      {isLoaded && (!sites || sites.length === 0) && (
        <div className="text-gray-600">No evaluation sites.</div>
      )}

      {isLoaded && sites && sites.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {sites.map((s) => (
            <SiteCard
              key={s.siteId}
              site={s}
              to={`/${currentOrgIdPrefix}/eval/${s.siteId}?window=${window}`}
            />
          ))}
        </div>
      )}
    </PageContainer>
  );
}
